/* eslint-disable react/jsx-pascal-case */
import { useContext, useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import { icons } from './icons';
import { StaticIconProps } from './types';
import { SvgContainer } from './styles';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';

const StaticIcon = ({
  name,
  size = 'medium',
  testId = 'icon-test-id',
  onClick,
  clickable,
}: StaticIconProps) => {
  const { actualTheme } = useContext(ThemeContext);
  const Icon = icons[name] || icons['pickit-user'];
  const handleClick = useCallback(() => {
    if (onClick) onClick();
  }, [onClick]);

  return (
    <ThemeProvider theme={actualTheme}>
      <SvgContainer size={size} data-testid={testId} onClick={handleClick} clickable={clickable}>
        <Icon.component
          height={actualTheme.basicIcon[size].size}
          width={actualTheme.basicIcon[size].size}
          viewBox="0 0 24 24"
        />
      </SvgContainer>
    </ThemeProvider>
  );
};

export default StaticIcon;
